import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import AutocompleteDropdown from '../../components/GarmentNavigator/AutocompleteDropdown'
import SlideSwitch from '../../components/SlideSwitch/SlideSwitch'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    background: 'white',
    width: 'calc(100% + 40px)',
    borderLeft: '1px solid #DAE0EA',
    borderRight: '1px solid #DAE0EA',
    borderBottom: '1px solid #DAE0EA',
    maxWidth: '1370px',
    padding: '15px 32px'
  },
  show: {
    height: 'auto'
  },
  hide: {
    height: '0px',
    display: 'none'
  },
  marketIdContainer: {
    width: '200px',
    marginRight: '5px'
  },
  brandContainer: {
    width: '300px',
    marginRight: '5px'
  },
  outfitTypeContainer: {
    width: '200px',
    marginRight: '5px'
  }
}))

export default function OutfitEditorAdvancedFilterBar (props) {
  const classes = useStyles()

  return (
    <div className={`${classes.root} ${props.show ? classes.show : classes.hide}`}>
      <div className={classes.marketIdContainer}>
        <AutocompleteDropdown
          title={'Market ID'}
          options={props.marketIds}
          onChange={props.handleMarketIdChange}
          placeholder={'Select Market ID'}
          value={props.marketId}
        />
      </div>
      <div className={classes.brandContainer}>
        <AutocompleteDropdown
          title={'Brand'}
          options={props.brands}
          onChange={props.handleBrandChange}
          placeholder={'Select Brand'}
          value={props.brand}
        />
      </div>
      <div className={classes.outfitTypeContainer}>
        <AutocompleteDropdown
          title={'Outfit Type'}
          options={props.outfitTypes}
          onChange={props.handleOutfitTypeChange}
          placeholder={'Select Outfit Type'}
          value={props.outfitType}
        />
      </div>
      {
        props.enableShowApprovedControls &&
        <div>
          <SlideSwitch
            title={'Approved Only'}
            handleChange={props.handleShowApprovedOnlyChange}
          />
        </div>
      }
      {
        props.enableShowApprovedControls &&
        <div>
          <SlideSwitch
            title={'Unapproved Only'}
            handleChange={props.handleShowUnapprovedOnlyChange}
          />
        </div>
      }
      <div>
        <SlideSwitch
          title={'Selection Default'}
          handleChange={props.handleSelectionDefaultChange}
        />
      </div>
    </div>
  )
}
